export const API_LOGIN_ENDPOINTS = {
    API: {
        API_AUTH_USER_LOGIN: 'API_AUTH_USER_LOGIN',
        API_AUTH_USER_LOGOUT: 'API_AUTH_USER_LOGOUT',
        API_AUTH_PASSWORD_FORGOT: 'API_AUTH_PASSWORD_FORGOT',
        API_AUTH_PASSWORD_RESET: 'API_AUTH_PASSWORD_RESET',
        API_AUTH_PASSWORD_CHANGE: 'API_AUTH_PASSWORD_CHANGE'
    }
};
